const TrainerCandidature = (props) => {
  const { candidature } = props;

  function formatDateOnly(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }
  return (
    <div className="trainer-candidature">
      <div className="trainer-candidature-title">Candidature</div>
      <div className="trainer-data-fields">
        {candidature.length > 0 ? (
          candidature.map((candidatura, i) => (
            <div key={i} className="trainer-data">
              <div className="trainer-field-row">
                <div className="trainer-field-label">Data Candidatura:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {formatDateOnly(candidatura.dataCandidatura)}
                  </span>
                </div>
              </div>
              <div className="trainer-field-row">
                <div className="trainer-field-label">Esito:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {candidatura.esito}
                  </span>
                </div>
              </div>
              {candidatura.descrizioneEsito && (
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Descrizione Esito:</div>
                  <div className="trainer-field-value">
                    <span className="trainer-span-value">
                      {candidatura.descrizioneEsito}
                    </span>
                  </div>
                </div>
              )}
              {candidatura.dataEsito && (
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Data Esito:</div>
                  <div className="trainer-field-value">
                    <span className="trainer-span-value">
                      {formatDateOnly(candidatura.dataEsito)}
                    </span>
                  </div>
                </div>
              )}
              {candidatura.autoreEsito && (
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Autore Esito:</div>
                  <div className="trainer-field-value">
                    <span className="trainer-span-value">
                      {formatDateOnly(candidatura.autoreEsito)}
                    </span>
                  </div>
                </div>
              )}
              <div className="trainer-field-row">
                <div className="trainer-field-label">Titolo Modulo:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {candidatura.titoloModulo}
                  </span>
                </div>
              </div>
              <div className="trainer-field-row">
                <div className="trainer-field-label">Sede Indirizzo:</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {candidatura.sedeIndirizzo}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">Nessuna candidatura.</div>
        )}
      </div>
    </div>
  );
};

export default TrainerCandidature;
